import { createRouter, createBrowserHistory } from "@tanstack/react-router";

import { rootRoute } from "./routes/__root";
import { indexRoute } from "./routes/index";
import { loginRoute } from "./routes/login";
import { shareRoute } from "./routes/share";
import {
  chatsLayoutRoute,
  chatsIndexRoute,
  chatDetailRoute,
  legacyProjectDetailRoute,
  projectsLayoutRoute,
  projectsIndexRoute,
  projectDetailRoute
} from "./routes/chats";
import {
  adminLayoutRoute,
  adminIndexRoute,
  adminFeedbackRoute,
  adminPromptRoute,
  adminUsersRoute,
  adminVectorStorageRoute,
  adminWordExportRoute
} from "./routes/admin";

const chatsRouteTree = chatsLayoutRoute.addChildren([
  chatsIndexRoute,
  legacyProjectDetailRoute,
  chatDetailRoute
]);

const projectsRouteTree = projectsLayoutRoute.addChildren([
  projectsIndexRoute,
  projectDetailRoute
]);

const adminRouteTree = adminLayoutRoute.addChildren([
  adminIndexRoute,
  adminFeedbackRoute,
  adminPromptRoute,
  adminUsersRoute,
  adminVectorStorageRoute,
  adminWordExportRoute
]);

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  shareRoute,
  chatsRouteTree,
  projectsRouteTree,
  adminRouteTree
]);

const browserHistory = createBrowserHistory();

export const router = createRouter({
  routeTree,
  history: browserHistory,
  defaultPreload: "intent"
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
